import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { NavStateService } from '../nav-state.service';
import { Subject, Subscription } from 'rxjs';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ngx-sub-nav',
  templateUrl: './sub-nav.component.html',
  styleUrls: ['./sub-nav.component.scss']
})
export class SubNavComponent implements OnInit,OnDestroy,OnChanges,AfterViewInit {
  @Input() context:any;
  items:NbMenuItem[];
  hasItems:boolean = false;
  subMenuItems$:Subscription;
  onItemClick$:Subscription;
  host:HTMLElement;


  private destroy$ = new Subject<void>();
  
  constructor(private navStateService:NavStateService,
    private menuService:NbMenuService,
    private readonly viewRef: ViewContainerRef){
    this.host = this.viewRef.element.nativeElement;
      
  }
  ngAfterViewInit(): void {
    const overLayContainer:HTMLElement = this.host.closest('.cdk-overlay-container');
    if(overLayContainer != undefined){
      const width = overLayContainer.offsetWidth;
      const boundingBox:HTMLElement = this.host.closest('.cdk-overlay-connected-position-bounding-box')
      const overLayPane:HTMLElement = this.host.closest('.cdk-overlay-pane');
      const popOverEl:HTMLElement = this.host.closest('nb-popover');
      boundingBox.style.width = "100%";
      overLayPane.style.width = "100%";
      popOverEl.style.width = "100%";
    }
    
   
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["context"]){
      //console.log(this.context);
    }
  }

  ngOnInit(): void {
    this.subMenuItems$ = this.navStateService.subMenuItems$.pipe(takeUntil(this.destroy$)).subscribe(items => {
      if(items != undefined){
        this.hasItems = true;
        this.stringToBoolean(items);
        this.items = items;
        this.items.forEach(item => {
          if(item.children != null){
            delete item.children;
          }
        });
        //console.log(this.items);
      }
    })
    this.onItemClick$ = this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuBag) => {
        console.log(menuBag);
      })
  }

  stringToBoolean(items:NbMenuItem[]):void{
    items.forEach(item => {
      if(item.hidden != undefined){
        let stringHidden = <string><unknown>item.hidden
        switch (stringHidden) {
          case "true":
            item.hidden = true;            
            break;
          case "false":
              item.hidden = false;            
              break;  
          default:
            console.log("What de fok");
            break;
        }
      }
      if(item.children != undefined){
        this.stringToBoolean(item.children);
      }
    })
  }

  /* private subscribeOnItemClick() {
    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === this.tag && this.trigger !== NbTrigger.NOOP),
        takeUntil(this.destroy$),
      )
      .subscribe();
  } */

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

/* private subscribeOnItemClick() {
  this.menuService.onItemClick()
    .pipe(
      filter(({ tag }) => tag === this.tag && this.trigger !== NbTrigger.NOOP),
      takeUntil(this.destroy$),
    )
    .subscribe(() => this.hide());
} */
